// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: dataframe.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { KGObservationProto } from "./analysis_plan";
import { DarwinHeader } from "./common";
import { ColumnHashProto } from "./data";

export const protobufPackage = "com.anko.darwin";

/** Details of a column in the KG dataframe. */
export interface DataFrameColumnProto {
  /** Output name of the column. */
  output_column_name?:
    | string
    | undefined;
  /**
   * True if column should be visible in the dataframe, false otherwise.
   * Some columns may be used to calculate other columns, in which case they can be marked as hidden.
   */
  is_visible?:
    | boolean
    | undefined;
  /**
   * Reference to a column in KG observation, referred by column hash.
   * This is set if this column refers to MKG entities in the KG observation.
   * If this column refers to some column in KG observation, Reference to KG observation column
   */
  column_hash?:
    | ColumnHashProto
    | undefined;
  /**
   * Evaluation expression (pandas) used for this column.
   * This is used for non-MKG columns in the dataframe.
   */
  eval_expression?:
    | string
    | undefined;
  /**
   * True if the eval expression represents an aggregate value, false otherwise.
   * If this is false, then eval expression is added as a column in dataframe.
   */
  is_aggregate_expression?:
    | boolean
    | undefined;
  /** String representation of JSON array of data values in this column. */
  data_value_json_array?: string | undefined;
}

/** Dataframe generated from a KG observation */
export interface KGDataFrameProto {
  /** The KG observation that generated this dataframe */
  kg_observation?:
    | KGObservationProto
    | undefined;
  /** Ordered list of columns */
  ordered_columns: DataFrameColumnProto[];
  /** Expression filters applied to rows */
  expression_filters: string[];
  /** Error messages during execution */
  error_messages: string[];
  /** List of columns on which sorting is applied. */
  sort_by_columns: KGDataFrameProto_SortByColumn[];
  /** Header containing metadata */
  header?: DarwinHeader | undefined;
}

export interface KGDataFrameProto_SortByColumn {
  /** Name of column */
  column_name?:
    | string
    | undefined;
  /** True if sort in ascending order, false otherwise */
  sort_asc?: boolean | undefined;
}

function createBaseDataFrameColumnProto(): DataFrameColumnProto {
  return {
    output_column_name: undefined,
    is_visible: undefined,
    column_hash: undefined,
    eval_expression: undefined,
    is_aggregate_expression: undefined,
    data_value_json_array: undefined,
  };
}

export const DataFrameColumnProto: MessageFns<DataFrameColumnProto> = {
  encode(message: DataFrameColumnProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.output_column_name !== undefined) {
      writer.uint32(10).string(message.output_column_name);
    }
    if (message.is_visible !== undefined) {
      writer.uint32(16).bool(message.is_visible);
    }
    if (message.column_hash !== undefined) {
      ColumnHashProto.encode(message.column_hash, writer.uint32(26).fork()).join();
    }
    if (message.eval_expression !== undefined) {
      writer.uint32(34).string(message.eval_expression);
    }
    if (message.is_aggregate_expression !== undefined) {
      writer.uint32(40).bool(message.is_aggregate_expression);
    }
    if (message.data_value_json_array !== undefined) {
      writer.uint32(50).string(message.data_value_json_array);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataFrameColumnProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataFrameColumnProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.output_column_name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.is_visible = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.column_hash = ColumnHashProto.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.eval_expression = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.is_aggregate_expression = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.data_value_json_array = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataFrameColumnProto {
    return {
      output_column_name: isSet(object.output_column_name) ? globalThis.String(object.output_column_name) : undefined,
      is_visible: isSet(object.is_visible) ? globalThis.Boolean(object.is_visible) : undefined,
      column_hash: isSet(object.column_hash) ? ColumnHashProto.fromJSON(object.column_hash) : undefined,
      eval_expression: isSet(object.eval_expression) ? globalThis.String(object.eval_expression) : undefined,
      is_aggregate_expression: isSet(object.is_aggregate_expression)
        ? globalThis.Boolean(object.is_aggregate_expression)
        : undefined,
      data_value_json_array: isSet(object.data_value_json_array)
        ? globalThis.String(object.data_value_json_array)
        : undefined,
    };
  },

  toJSON(message: DataFrameColumnProto): unknown {
    const obj: any = {};
    if (message.output_column_name !== undefined) {
      obj.output_column_name = message.output_column_name;
    }
    if (message.is_visible !== undefined) {
      obj.is_visible = message.is_visible;
    }
    if (message.column_hash !== undefined) {
      obj.column_hash = ColumnHashProto.toJSON(message.column_hash);
    }
    if (message.eval_expression !== undefined) {
      obj.eval_expression = message.eval_expression;
    }
    if (message.is_aggregate_expression !== undefined) {
      obj.is_aggregate_expression = message.is_aggregate_expression;
    }
    if (message.data_value_json_array !== undefined) {
      obj.data_value_json_array = message.data_value_json_array;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataFrameColumnProto>, I>>(base?: I): DataFrameColumnProto {
    return DataFrameColumnProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataFrameColumnProto>, I>>(object: I): DataFrameColumnProto {
    const message = createBaseDataFrameColumnProto();
    message.output_column_name = object.output_column_name ?? undefined;
    message.is_visible = object.is_visible ?? undefined;
    message.column_hash = (object.column_hash !== undefined && object.column_hash !== null)
      ? ColumnHashProto.fromPartial(object.column_hash)
      : undefined;
    message.eval_expression = object.eval_expression ?? undefined;
    message.is_aggregate_expression = object.is_aggregate_expression ?? undefined;
    message.data_value_json_array = object.data_value_json_array ?? undefined;
    return message;
  },
};

function createBaseKGDataFrameProto(): KGDataFrameProto {
  return {
    kg_observation: undefined,
    ordered_columns: [],
    expression_filters: [],
    error_messages: [],
    sort_by_columns: [],
    header: undefined,
  };
}

export const KGDataFrameProto: MessageFns<KGDataFrameProto> = {
  encode(message: KGDataFrameProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kg_observation !== undefined) {
      KGObservationProto.encode(message.kg_observation, writer.uint32(10).fork()).join();
    }
    for (const v of message.ordered_columns) {
      DataFrameColumnProto.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.expression_filters) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.error_messages) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.sort_by_columns) {
      KGDataFrameProto_SortByColumn.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.header !== undefined) {
      DarwinHeader.encode(message.header, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KGDataFrameProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKGDataFrameProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.kg_observation = KGObservationProto.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ordered_columns.push(DataFrameColumnProto.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.expression_filters.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.error_messages.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.sort_by_columns.push(KGDataFrameProto_SortByColumn.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KGDataFrameProto {
    return {
      kg_observation: isSet(object.kg_observation) ? KGObservationProto.fromJSON(object.kg_observation) : undefined,
      ordered_columns: globalThis.Array.isArray(object?.ordered_columns)
        ? object.ordered_columns.map((e: any) => DataFrameColumnProto.fromJSON(e))
        : [],
      expression_filters: globalThis.Array.isArray(object?.expression_filters)
        ? object.expression_filters.map((e: any) => globalThis.String(e))
        : [],
      error_messages: globalThis.Array.isArray(object?.error_messages)
        ? object.error_messages.map((e: any) => globalThis.String(e))
        : [],
      sort_by_columns: globalThis.Array.isArray(object?.sort_by_columns)
        ? object.sort_by_columns.map((e: any) => KGDataFrameProto_SortByColumn.fromJSON(e))
        : [],
      header: isSet(object.header) ? DarwinHeader.fromJSON(object.header) : undefined,
    };
  },

  toJSON(message: KGDataFrameProto): unknown {
    const obj: any = {};
    if (message.kg_observation !== undefined) {
      obj.kg_observation = KGObservationProto.toJSON(message.kg_observation);
    }
    if (message.ordered_columns?.length) {
      obj.ordered_columns = message.ordered_columns.map((e) => DataFrameColumnProto.toJSON(e));
    }
    if (message.expression_filters?.length) {
      obj.expression_filters = message.expression_filters;
    }
    if (message.error_messages?.length) {
      obj.error_messages = message.error_messages;
    }
    if (message.sort_by_columns?.length) {
      obj.sort_by_columns = message.sort_by_columns.map((e) => KGDataFrameProto_SortByColumn.toJSON(e));
    }
    if (message.header !== undefined) {
      obj.header = DarwinHeader.toJSON(message.header);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KGDataFrameProto>, I>>(base?: I): KGDataFrameProto {
    return KGDataFrameProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KGDataFrameProto>, I>>(object: I): KGDataFrameProto {
    const message = createBaseKGDataFrameProto();
    message.kg_observation = (object.kg_observation !== undefined && object.kg_observation !== null)
      ? KGObservationProto.fromPartial(object.kg_observation)
      : undefined;
    message.ordered_columns = object.ordered_columns?.map((e) => DataFrameColumnProto.fromPartial(e)) || [];
    message.expression_filters = object.expression_filters?.map((e) => e) || [];
    message.error_messages = object.error_messages?.map((e) => e) || [];
    message.sort_by_columns = object.sort_by_columns?.map((e) => KGDataFrameProto_SortByColumn.fromPartial(e)) || [];
    message.header = (object.header !== undefined && object.header !== null)
      ? DarwinHeader.fromPartial(object.header)
      : undefined;
    return message;
  },
};

function createBaseKGDataFrameProto_SortByColumn(): KGDataFrameProto_SortByColumn {
  return { column_name: undefined, sort_asc: undefined };
}

export const KGDataFrameProto_SortByColumn: MessageFns<KGDataFrameProto_SortByColumn> = {
  encode(message: KGDataFrameProto_SortByColumn, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.column_name !== undefined) {
      writer.uint32(10).string(message.column_name);
    }
    if (message.sort_asc !== undefined) {
      writer.uint32(16).bool(message.sort_asc);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KGDataFrameProto_SortByColumn {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKGDataFrameProto_SortByColumn();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.column_name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.sort_asc = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KGDataFrameProto_SortByColumn {
    return {
      column_name: isSet(object.column_name) ? globalThis.String(object.column_name) : undefined,
      sort_asc: isSet(object.sort_asc) ? globalThis.Boolean(object.sort_asc) : undefined,
    };
  },

  toJSON(message: KGDataFrameProto_SortByColumn): unknown {
    const obj: any = {};
    if (message.column_name !== undefined) {
      obj.column_name = message.column_name;
    }
    if (message.sort_asc !== undefined) {
      obj.sort_asc = message.sort_asc;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KGDataFrameProto_SortByColumn>, I>>(base?: I): KGDataFrameProto_SortByColumn {
    return KGDataFrameProto_SortByColumn.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KGDataFrameProto_SortByColumn>, I>>(
    object: I,
  ): KGDataFrameProto_SortByColumn {
    const message = createBaseKGDataFrameProto_SortByColumn();
    message.column_name = object.column_name ?? undefined;
    message.sort_asc = object.sort_asc ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
